var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'react-emotion';
import Typography from '@material-ui/core/Typography';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 200px;\n"], ["\n  min-width: 200px;\n"])));
export var Title = styled(Typography)({
    '&&': {
        fontWeight: 90
    }
});
export var CustomHelperText = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n"], ["\n  color: ", ";\n  font-size: 13px;\n"])), function (props) { return (props.error ? 'red' : 'rgba(0, 0, 0, 0.54)'); });
var templateObject_1, templateObject_2;
//# sourceMappingURL=EditableTextField.Styles.js.map